/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_flech': {
    width: 45,
    height: 45,
    viewBox: '0 0 45 45',
    data: '<path pid="0" d="M13.067 13.652a1.409 1.409 0 001.991 0l6.036-6.039V26.72a1.406 1.406 0 002.812 0V7.613l6.036 6.039a1.408 1.408 0 001.991-1.991l-8.437-8.438a1.406 1.406 0 00-1.992 0l-8.437 8.438a1.406 1.406 0 000 1.99zM22.5 42.188a5.625 5.625 0 100-11.25 5.625 5.625 0 000 11.25zm0-2.813a2.813 2.813 0 110-5.625 2.813 2.813 0 010 5.625z" _fill="#5F01D3"/>'
  }
})
